// ── Importaciones tal cual ──────────────────────────────
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../NavBar/Navbar';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import { Tabs, Tab } from 'react-bootstrap';
import ModalBranchofficeSelect from '../NavBar/ModalBranchofficeSelect';
import { useSelectedBranch } from '../../../context/BranchContext';
import VendingTable from './VendingTable';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import SupportBot from '../SupportBot/SupportBot';

import './vending.css';
import AppShell from '../../page/AppShell/AppShell';
import MainContent from '../MainContent/MainContent';


/* ── ICONS ── */
const IcoVending = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="3" y="2" width="18" height="20" rx="2" />
    <path d="M8 2v20M3 8h5M3 12h5M3 16h5" />
    <rect x="11" y="6" width="6" height="4" rx="1" />
    <rect x="11" y="13" width="6" height="4" rx="1" />
  </svg>
);
const IcoStore = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

/* ════════════════════════════════════════════════════════
   COMPONENT
════════════════════════════════════════════════════════ */
const VendingPanel = () => {

  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  let { business_code } = useParams();
  let user = JSON.parse(localStorage.getItem('user'));

  const [userBranchoffices, setUserBranchs] = useState([]);
  const { selectedBranch, setSelectedBranch } = useSelectedBranch();
  const [eventHandler, setEventHandler] = useState(0);
  let token = localStorage.getItem('x-access-token');

  const getBranchoffice = async (code) => {
    try {
      const branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(business_code, code);
      setSelectedBranch({
        name: branch.data.branchoffice.name,
        code: branch.data.branchoffice.code,
        id: branch.data.branchoffice.id
      });
      setEventHandler(eventHandler + 1);
    } catch (err) {
      setSelectedBranch({ code: 0, id: 0 });
      setEventHandler(eventHandler + 1);
    }
  };

  const actionSelectBranch = (branchCode) => { getBranchoffice(branchCode); };

  const branchList = () => {
    const listBracnh = userBranchoffices.map((branch) => (
      <option key={branch.code} value={branch.code}>{branch.branchoffice_name}</option>
    ));
    return listBracnh;
  };

  useEffect(() => {
    (async () => {
      try {
        console.log(user);
        setUserBranchs(user.branchoffices);
      } catch (err) {
        console.log(err);
      }
    })();
  }, []);
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  return (
    <>
      <AppShell route="vending">
        <MainContent>

          <div>

            {/* ── BANNER ── */}
            {/* header Original: Review CSS */}
            <div className="ts-top">
              <div className="ts-top__left">
                <div>
                  <div className="ts-top__title">Vendings</div>
                  <div className="ts-top__sub">

                    {/* {
                      selectedBranch.name && (
                        <span className="vp-banner-branch">
                          {selectedBranch.name}
                        </span>
                      )} */}
                    {selectedBranch.name
                      ? `Máquinas expendedoras · ${selectedBranch.name}`
                      : 'Selecciona una sucursal para ver sus máquinas'}
                  </div>
                </div>
              </div>
              <div className="ts-top__right">
                <ModalBranchofficeSelect actionSelectBranch={actionSelectBranch} />
              </div>
            </div>
            {/* End header Original: Review CSS */}

            {/* ── CONTENIDO ── */}
            {!selectedBranch.name ? (

              /* Empty state cuando no hay sucursal */
              <div className="vp-no-branch">
                <div className="vp-no-branch-icon"><IcoStore /></div>
                <p className="vp-no-branch-title">Ninguna sucursal seleccionada</p>
                <p className="vp-no-branch-sub">
                  Selecciona una sucursal en la barra superior para ver sus máquinas vending.
                </p>
              </div>

            ) : (

              /* VendingTable — props originales intactos */
              <div className="vp-content">
                {selectedBranch && (
                  <VendingTable
                    branchoffice_id={selectedBranch ? selectedBranch.id : 0}
                    eventHandler={eventHandler}
                    token={token}
                    user={user}
                  />
                )}
              </div>

            )}

            {/* opciones comentadas originales — preservadas como referencia */}
            {/* <div className="mt-2">
              <select onChange={e => getBranchoffice(e.target.value)} className='form-select' name="user_branch" id="user_branch">
                <option value={0}>Mostrar todos</option>
                {branchList()}
              </select>
            </div> */}

          </div>

        </MainContent>
      </AppShell>

      {/* imports no-JSX preservados */}
      {void [Navbar, Row, Col, Tabs, Tab, SupportBot, branchList]}
    </>
  );
};

export default VendingPanel;